import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`My academic experience, working as an Assistant Professor with a solid research background and
teaching various online and face to face courses. I am interested in developing a career that combines teaching and
research while maintaining my interest in health data analysis and data science with computer application and the broader STEM field.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Email:`}</strong>{` `}<a parentName="p" {...{
            "href": "mailto:johndoe@johndoe.com"
          }}>{`johndoe@johndoe.com`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Mailing Address:`}</strong>{` Department of Mathematics, The Best Math Room 9876, Toronto ON, M5S 2E4`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Office:`}</strong>{` 199B MATH`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Office Hours:`}</strong></p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`Mon: 10:15-11:05, 12:15-1:05`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Tue: 2:15-3:05`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Thu: 10:15-11:05`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Fri: 11:15-12:05`}</p>
          </li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      